import { render, staticRenderFns } from "./Ykbb.vue?vue&type=template&id=5a1940fa&scoped=true&"
import script from "./Ykbb.vue?vue&type=script&lang=js&"
export * from "./Ykbb.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a1940fa",
  null
  
)

export default component.exports